{
  "translations": {
    "global": {
      "cancel": "Cancel",
      "submit": "Submit",
      "fieldRequired": "*Required"
    },
    "shiftForm": {
      "activeSites": "Active Sites",
      "adminNotesHeader": "Admin Notes",
      "dateLabel": "Date",
      "englishTab": "English",
      "frequencyLabel": "Frequency",
      "frequencyCustomLabel": "Custom...",
      "frequencyRepeatUntilLabel": "Until",
      "frequencyRepeatUntilForever": "Repeats forever",
      "frequencyRepeatUntilDate": "Until date",
      "frequencyRepeatNumOfShifts": "# of shifts",
      "frequencyRepeatNumOfShiftsLabel": "Number",
      "frequencyWeeklyOnDayPrefix": "Weekly on",
      "frequencyMonthlyOnDayPrefix": "Monthly on",
      "frequencyYearlyOnDatePrefix": "Yearly on",
      "frequencyEveryWeekday": "Every Weekday (Monday to Friday)",
      "frequencyRepeatEndLabel": "Ends",
      "frequencyRepeatEndsNever": "Never",
      "frequencyRepeatEndsOn": "On",
      "frequencyRepeatEndsAfter": "After",
      "frequencyRepeatForOccurrences": "occurrence(s)",
      "inactiveSites": "Inactive Sites",
      "nameLabel": "Shift Name",
      "publicNotesHeader": "Shift Instructions",
      "spanishTab": "Spanish",
      "submitForm": "Submit",
      "taskLabel": "Tasks",
      "tasksHeader": "Tasks",
      "tasksMenuPlaceholder": "Add a task",
      "tasksRemove": "Remove task",
      "timeRangeJoiner": "to",
      "userLabel": "Volunteer",
      "userMenuPlaceholder": "Add a volunteer",
      "usersHeader": "Volunteers",
      "usersRemove": "Remove volunteer",
      "volunteerMinimumLabel": "Minimum number of volunteers required"
    },
    "rRule": {
      "customRecurrence": "Custom Recurrence",
      "daily": "Daily",
      "day": "day",
      "dayDays": "day(s)",
      "doesNotRepeat": "Does not repeat",
      "each": "each",
      "fifth": "fifth",
      "first": "first",
      "fourth": "fourth",
      "friday": "Friday",
      "fridayCode": "FR",
      "last": "last",
      "monday": "Monday",
      "mondayCode": "MO",
      "monthMonths": "month(s)",
      "nd": "nd",
      "onThe": "on the",
      "rd": "rd",
      "repeat": "Repeat",
      "repeatEvery": "Repeat every",
      "repeatOn": "Repeat on",
      "saturday": "Saturday",
      "saturdayCode": "SA",
      "second": "second",
      "st": "st",
      "sunday": "Sunday",
      "sundayCode": "SU",
      "th": "th",
      "third": "third",
      "thursday": "Thursday",
      "thursdayCode": "TH",
      "tuesday": "Tuesday",
      "tuesdayCode": "TU",
      "wednesday": "Wednesday",
      "wednesdayCode": "WE",
      "weekCodes": "SU,MO,TU,WE,TH,FR,SA",
      "weekday": "weekday",
      "weekdayCodes": "MO,TU,WE,TH,FR",
      "weekendCodes": "SU,SA",
      "weekWeeks": "weeks(s)",
      "weekendDay": "weekend day"
    }
  }
}
